import { Amplify } from 'aws-amplify';

let configured = false;

/**
 * Amplify v6 configuration for the admin portal.
 *
 * Pool-per-actor (2026-07-04): the portal authenticates against the dedicated
 * EMPLOYEE Cognito pool (admin-create-only, MFA required) through its own
 * /login form — it no longer piggybacks on the public site's consumer-pool
 * login. Two deliberate omissions vs the old config:
 *
 *  - NO identity pool: the employee pool has none, and the portal makes no
 *    IAM-signed calls (admin-api takes the id token as a bearer).
 *  - NO cross-subdomain cookie storage: the session originates on this
 *    origin, so Amplify's default per-origin storage is correct — sharing
 *    a `.grocerylistplus.com` cookie with the consumer apps would be wrong
 *    (different pool, different audience).
 */
export function configureAmplify(): void {
  if (configured) return;

  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID as string;
  const userPoolClientId = import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID as string;

  if (!userPoolId || !userPoolClientId) {
    console.error('[admin-portal] missing Cognito env — auth will not work');
    return;
  }

  Amplify.configure({
    Auth: {
      Cognito: { userPoolId, userPoolClientId },
    },
  });

  configured = true;
}
